// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myProjectsOverviewStyles } from "@conklin/App/Widgets/MyProjectsOverview/MyProjectsOverview";
import { LazyImageStyle } from "@conklin/MobiusOverrides/LazyImage";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, ellipsis, linkArrowStyle, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

myProjectsOverviewStyles.wrapper = {
    css: css`
        display: flex;
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        flex-direction: column;
    `,
};
myProjectsOverviewStyles.heading = {
    css: css`
        display: flex;
        justify-content: space-between;
        padding: 8px 12px;
        align-items: center;
        border-radius: 4px 4px 0 0;
        color: ${color("common.ui1")};
        background-color: ${color("primary.main")};
    `,
};
myProjectsOverviewStyles.title = {
    variant: "h4",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};
myProjectsOverviewStyles.link = linkArrowStyle("small", {
    css: css`
        align-self: center;
    `,
});

myProjectsOverviewStyles.centeredContent = {
    css: css`
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 80px;
    `,
};

myProjectsOverviewStyles.body = {
    css: css`
        background-color: ${color("common.ui1")};
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 0 12px 12px 12px;

        ${xScreen("lte", "md")} {
            flex-wrap: nowrap;
        }

        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};

myProjectsOverviewStyles.createListModal = {
    sizeVariant: "small",
};

myProjectsOverviewStyles.listCard = {
    css: css`
        display: flex;
        gap: 12px;
        padding-top: 12px;
        padding-bottom: 12px;
        border-bottom: 1px solid ${color("common.border")};
        ${LazyImageStyle} {
            flex: 0 0 52px;
        }
    `,
};
myProjectsOverviewStyles.listImage = {
    width: "52px",
    height: "52px",
    css: css`
        min-width: 52px;
        object-fit: contain;
    `,
};

myProjectsOverviewStyles.buttonViewLink = {
    variant: "secondary",
    sizeVariant: "small",
};

myProjectsOverviewStyles.listTitle = {
    typographyProps: {
        size: 12,
        lineHeight: "15px",
        weight: fontConfig.weight.bold,
        css: css`
            ${ellipsis(2)}
            text-overflow: ellipsis;
            max-width: 180px;
            display: inline-block;
        `,
    },
    color: "text",
};

myProjectsOverviewStyles.infoContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

myProjectsOverviewStyles.listInfoText = {
    size: 12,
    lineHeight: "15px",
};

myProjectsOverviewStyles.noItemsMessage = {
    size: 14,
    lineHeight: "22px",
    css: css`
        padding: 12px 0 0;
    `,
};
